module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDggNTEyIj48cGF0aCBkPSJNNDQ4IDgwdjM1MmMwIDI2LjUtMjEuNSA0OC00OCA0OGgtODUuM1YzMDIuOGg2MC42bDguNy02Ny42aC02OS4zVjE5MmMwLTE5LjYgNS40LTMyLjkgMzMuNS0zMi45SDM4NFY5OC43Yy02LjItLjgtMjcuNC0yLjctNTIuMi0yLjctNTEuNiAwLTg3IDMxLjUtODcgODkuNHY0OS45SDE4NHY2Ny42aDYwLjlWNDgwSDQ4Yy0yNi41IDAtNDgtMjEuNS00OC00OFY4MGMwLTI2LjUgMjEuNS00OCA0OC00OGgzNTJjMjYuNSAwIDQ4IDIxLjUgNDggNDh6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/facebook.svg
// module id = k7cH
// module chunks = 0